import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import businessProfileStoreService from 'legacy/lut/classes/services/BusinessProfileStoreService'
import { ConnectionIssue } from 'legacy/lut/components/widgets/public/ConnectionIssue'

import { NotificationController } from 'core-components/library/popup'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { HttpCancel } from 'core/classes/http'
import { CrudStore } from 'core/types/crudStore'

export const getAdditionalData = async (contactId: string) => {
  let ContactCampaigns = []
  let UserRights = []

  if (contactId) {
    const contactFilter = {
      field: 'ContactId',
      operator: Operator.EQUAL,
      value: contactId,
    }

    const crudUserRights = CrudStore.get(
      CrudStoreItem.ContactCodeRequests,
      'ContactData-getAllCodes-UserRights'
    )

    const filterUserRights: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        contactFilter,
        {
          field: 'Type',
          operator: Operator.CONTAINS,
          value: 'UserRights',
        },
      ],
    }
    crudUserRights.setFilter(filterUserRights)
    const userRightsRequests = (await crudUserRights.fetch()).items

    const crudCampaigns = CrudStore.get(
      CrudStoreItem.ContactCodeRequests,
      'ContactData-getAllCodes-Campaigns'
    )
    const filterCampaigns: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [
        contactFilter,
        {
          field: 'Type',
          operator: Operator.CONTAINS,
          value: 'Campaigns',
        },
      ],
    }
    crudCampaigns.setFilter(filterCampaigns)
    const campaignsRequests = (await crudCampaigns.fetch()).items

    const result = await businessProfileStoreService.getUserRightsAndCampaigns(
      [contactId],
      new HttpCancel(),
      1000
    )
    const data = {
      ...result,
      userRights: {
        items: result?.userRights.items.slice() || [],
        total: result?.userRights.total || 0,
      },
      contactCampaigns: {
        items: result?.contactCampaigns.items.slice() || [],
        total: result?.userRights.total || 0,
      },
    }

    if (userRightsRequests) {
      let newUserRights = data.userRights.items || []
      userRightsRequests.forEach((item) => {
        newUserRights = newUserRights.filter((v) => v?.USER_RIGHTS !== item.Code)
        newUserRights.push({ ...item, CONTACT_ID: contactId })
      })
      data.userRights.items = newUserRights
    }
    if (campaignsRequests) {
      let newCampaigns = data.contactCampaigns.items || []
      campaignsRequests.forEach((item) => {
        newCampaigns = newCampaigns.filter((v) => v?.CAMPAIGNS !== item.Code)
        newCampaigns.push({ ...item, CONTACT_ID: contactId })
      })
      data.contactCampaigns.items = newCampaigns
    }
    if (!campaignsRequests) {
      NotificationController.show({
        content: () => <ConnectionIssue />,
      })
    }

    if (data) {
      ContactCampaigns = data.contactCampaigns.items
      UserRights = data.userRights.items
    }
  }

  return { ContactCampaigns, UserRights }
}
